import { createLogic } from "redux-logic";
import { setLocal } from "../../../data/localStorageHelpers";
import { IntegrationsActions, INTEGRATIONS_LOCAL_STORAGE_KEYS } from "../types";
var queryParamsFound = createLogic({
    type: IntegrationsActions.INTEGRATIONS_EVENT_QUERY_PARAMS_FOUND,
    latest: true,
    process: function (_a, dispatch, done) {
        var action = _a.action;
        var typedAction = action;
        var params = new URLSearchParams(typedAction.payload);
        var referralRockCode = params.get("referralcode");
        if (!!referralRockCode) {
            setLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_CODE, referralRockCode);
        }
        var referralRockWCID = params.get("rr_wcid");
        if (!!referralRockWCID) {
            setLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_WCID, referralRockWCID);
        }
        done();
    },
});
var exportable = [queryParamsFound];
export default exportable;
